module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "overflow-x": "hidden"
    }
  }, [_vm._m(0), _vm._v(" "), _c('header', {
    staticClass: "header-area single-page x-header",
    attrs: {
      "id": "testNavBar"
    }
  }, [_c('div', {
    staticClass: "header-top"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "tools"
  }, [_c('div', {
    staticClass: "logo-area"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticClass: "i",
    attrs: {
      "src": "http://en.sc.ruc.edu.cn/static/images/logo-light.png",
      "alt": "logo"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "i",
    attrs: {
      "src": "http://en.sc.ruc.edu.cn/static/images/logo-light.png",
      "alt": "logo"
    }
  })])], 1), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12",
    class: {
      fixedNavbar: _vm.isfixTab
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "main-menu main-menu-light"
  }, [_c('ul', {
    staticClass: "main-menu-item-ul"
  }, [_c('li', {
    staticClass: "main-menu-item-ul-li",
    class: [_vm.routerName == 'home' ? 'active' : '']
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', {
    staticClass: "main-menu-item-ul-li",
    class: [_vm.routerName == 'about' ? 'active' : '']
  }, [_c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("About")]), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/about#message"
    }
  }, [_vm._v("Dean's message")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/about#leader"
    }
  }, [_vm._v("Current leaders")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/about#map"
    }
  }, [_vm._v("Campus map")])], 1)])], 1), _vm._v(" "), _c('li', {
    staticClass: "main-menu-item-ul-li",
    class: [_vm.routerName == 'introduction' ? 'active' : '']
  }, [_c('router-link', {
    attrs: {
      "to": "/introduction"
    }
  }, [_vm._v("Introduction")]), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/introduction#campus"
    }
  }, [_vm._v("About the Campus")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/introduction#majors"
    }
  }, [_vm._v("Majors")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/introduction#Employment"
    }
  }, [_vm._v("Enrollment & Employment")])], 1)])], 1), _vm._v(" "), _c('li', {
    staticClass: "main-menu-item-ul-li",
    class: [_vm.routerName == 'schools' ? 'active' : '']
  }, [_c('router-link', {
    attrs: {
      "to": "/schoolDetails?id=1"
    }
  }, [_vm._v("Schools")]), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/schoolDetails?id=1"
    }
  }, [_vm._v("Sino-French Institute")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/schoolDetails?id=2"
    }
  }, [_vm._v("School of Smart Governance")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/schoolDetails?id=3"
    }
  }, [_vm._v("Silk Road School")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/schoolDetails?id=4"
    }
  }, [_vm._v("International College")])], 1)])], 1), _vm._v(" "), _c('li', {
    staticClass: "main-menu-item-ul-li",
    class: [_vm.routerName == 'collaboration' ? 'active' : '']
  }, [_c('router-link', {
    attrs: {
      "to": "/collaboration"
    }
  }, [_vm._v("Collaboration")])], 1)])])])])])]), _vm._v(" "), _c('router-view'), _vm._v(" "), _vm._m(3)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preloader"
  }, [_c('div', {
    staticClass: "spinner"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tools-mod"
  }, [_c('a', {
    staticClass: "tools-item lang",
    attrs: {
      "href": "http://sc.ruc.edu.cn/",
      "target": "_blank"
    }
  }, [_vm._v("中")]), _vm._v(" "), _c('div', {
    staticClass: "tools-item search-mod"
  }, [_c('div', {
    staticClass: "search-box"
  }, [_c('div', {
    staticClass: "search-txt"
  }, [_c('input', {
    staticClass: "search-input",
    attrs: {
      "type": "text",
      "name": "search",
      "id": "input1",
      "placeholder": "Search"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "search-btn"
  }, [_c('button', {
    staticClass: "search-submit",
    attrs: {
      "id": "search",
      "type": "submit"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-navbar"
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer-area"
  }, [_c('div', {
    staticClass: "footer-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "footer-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "footer-logo wow slideInLeft"
  }, [_c('a', {
    attrs: {
      "href": "index.html"
    }
  }, [_c('img', {
    attrs: {
      "src": "http://en.sc.ruc.edu.cn/static/images/home/footer-logo.png",
      "alt": "logo"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "footer-text wow slideInRight"
  }, [_c('h2', [_vm._v("CONTACT")]), _vm._v(" "), _c('p', [_vm._v("\n              Add:No.158 Ren'ai Road, Dushulake High Education District, Suzhou, Jiangsu Province,215123,P.R.  China\n            ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "20px",
      "font-weight": "900"
    }
  }, [_vm._v("\n                AboutPrivacy copyright  Copyright © 2023 RUC.EDU.CN  "), _c('a', {
    attrs: {
      "href": "https://beian.miit.gov.cn/"
    }
  }, [_vm._v("京公网安备110402430004号")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://beian.miit.gov.cn/"
    }
  }, [_vm._v("京ICP备05007162号-1")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "footer-right"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-002e7b8c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 66
// module chunks = 0